import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';
import { APIConstants, Constants } from '../../common';
import { CommonService } from '../common.service';


export const authInterceptor: HttpInterceptorFn = (req, next) => {

  const authService = inject(AuthService);
  const commonService = inject(CommonService);

  let reqWithHeader = req.clone();

  const excludedEndpoints = [
    APIConstants.tokenAuth,
    APIConstants.register,
    APIConstants.forgotPassword,
    APIConstants.verificationCode,
    APIConstants.resetPassword
  ];

  const isS3PresignedUrl =
    req.url.includes('amazonaws.com') || // AWS S3 URL
    req.url.includes('X-Amz-Signature'); // Presigned URL signature

  const subscriptionExpiredMessage = 'Your subscription plan has expired';

  const extractErrorMessage = (errorBody: unknown): string => {
    if (!errorBody) return '';
    if (typeof errorBody === 'string') return errorBody;

    if (typeof errorBody === 'object') {
      const payload = errorBody as Record<string, unknown>;
      const candidates = [
        payload['error'],
        payload['message'],
        payload['detail'],
        payload['non_field_errors'],
        payload['error_message']
      ];

      for (const candidate of candidates) {
        if (typeof candidate === 'string') return candidate;
        if (Array.isArray(candidate) && candidate.length > 0 && typeof candidate[0] === 'string') {
          return candidate[0];
        }
      }
    }

    return '';
  };

  const triggerSubscriptionExpiredPopup = () => {
    commonService.openSubscriptionExpiredPopup.next();
  };

  if (!excludedEndpoints.some(endpoint => req.url.endsWith(endpoint)) && !isS3PresignedUrl ) {
    const token = localStorage.getItem(Constants.localStorageItem.token);
    reqWithHeader = req.clone({
      headers: req.headers.set('Authorization', 'Token ' + token),
    });
  }

  // Check for offline status
  if (!navigator.onLine) {
    commonService.isLoading = false;

    const result = commonService.openDialog({
      type: 'confirmation',
      title: 'No Internet Connection',
      subtitle: 'You are currently offline. Please check your internet connection.',
      yesButtonText: 'Retry',
      noButtonText: 'No'
    });

    result.then(value => {
      if (value) {
        window.location.reload();
      }
    })
    // Return an observable error since there's no internet
    return throwError(() => new HttpErrorResponse({ error: 'No Internet Connection', status: 0 }));
  }

  return next(reqWithHeader).pipe(
    catchError((error: HttpErrorResponse) => {
      const errorMessage = extractErrorMessage(error.error);
      if (errorMessage.includes(subscriptionExpiredMessage)) {
        commonService.isLoading = false;
        triggerSubscriptionExpiredPopup();
      }

      if (error.status === 401 && !(req.url.endsWith(APIConstants.clearToken))) {
        commonService.isLoading = false;

        const result = commonService.openDialog({
          type: 'error',
          title: 'Authentication Failed',
          subtitle: Constants.notifyMessages.authenticationFailed,
          yesButtonText: 'Logout'
        });

        result.then(value => {
          if (value) {
            authService.logout();
          }
        })
      }
      return throwError(() => error);
    })
  );
};

